<template lang='pug'>
  renderer(ref='renderTools',@start='startLoading',
    :force-canvas='true',
    @stop='doneLoading',
    :key='transform.id',
    :layers='from.layers'
    :background-color='backgroundColor')
    template(#loading)
      loading(:is-full-page='false',':active'='true')
    template(#view='{renderTools,container,pixiApp}')
      transform(:transform='transform',
        :parent-container='container',
        :render-tools='renderTools'
        :partutil='partutil'
        )
</template>
<script>
import FlowLoader from './FlowLoader.vue';
import Renderer from './Renderer.vue';
import Partutil from '@edit/tree/partutil.js';
import Transform from './Transform.vue';
let PIXI = require('pixi.js-legacy');

export default {
  props:{
    transform:{
      type:Object,
      required:true
    },
    from:{
      type:Object,
      required:true
    },
    source:{
      type:String,
      required:true
    },
    gamedata:{
      type:Object,
      required:true
    },
    scale:{
      type:Object,
      default() {
        return {
          x:16,
          y:16
        }
      }
    },
    backgroundColor:{
      type:String,
      default:'#000000'
    }
  },
  components:{
    Transform,
    FlowLoader,
    Renderer
  },
  data() {
    const partutil = new Partutil({
      from:this.from,
      source:this.source,
      gamedata:this.gamedata
    });
    return {
      loading:false,
      partutil
    }
  },
  methods:{
    startLoading({container,pixiApp}) {
      this.loading = true;
    },
    doneLoading({container,pixiApp,renderTools}) {
      this.loading = false;
      this.sizeToFit({container,pixiApp,renderTools});
    },
    getScale(width, height) {
      //console.log('setSCALE', width, height);

      const component = this.partutil.findComponentForTransform(this.transform);
      let cols = this.transform.transform.scale.x * this.transform.transform.localScale.x;
      let rows = this.transform.transform.scale.y * this.transform.transform.localScale.y;
      if (component.type === 'text') {
        // lol
        cols *= 3;
      }
      
      if (width < height) {
        /*
        let hax = 1080;
        if (width/height < 0.7) {
          hax = 1180;
        }
        if (width/height < 0.6) {
          hax = 1380;
        }
        */
        const scale = Math.min(
          width / cols / (1920/16),
          height / rows / (1080/9), // lol iphone x?!?!?
          Math.max(
            width / rows / (1080/9),
            height / cols / (1920/16)
          )
        );
        return scale;
      } else {
        const scale = Math.min(
          width / cols / (1080/9),
          height / rows / (1920/16),
          width / rows / (1920/9),
          height / cols / (1280/16)
        );
        return scale;
      }

    },

    sizeToFit({renderTools,container,pixiApp}) {
      const renderer = pixiApp.renderer;
      renderTools.addToRunBatch( () => {
      renderTools.addToRunBatch( () => {

      const stageBounds = pixiApp.stage.getBounds();
      const bounds = container.getBounds();
      const middle = {
        x:bounds.width/2,
        y:bounds.height/2
      }
      //this.scale.x = 600 * (1/stageBounds.width);
      //this.scale.y = 600 * (1/stageBounds.height);
      //container.scale.set(s, s);

      const scale = {
        x:renderer.width / bounds.width,
        y:renderer.height / bounds.height
      }
      const s = this.getScale(renderer.width, renderer.height);
      console.log('s', s);
      const s2 = {
        x:this.transform.transform.pos.x * (1920/16),
        y:this.transform.transform.pos.y * (1920/16)
      }

      //pixiApp.stage.position.set(renderer.width/2, renderer.height/2);
      pixiApp.stage.scale.set(s, s);
      console.log('loooooooool', s2.x,s2.y);
      pixiApp.stage.pivot.set(-5,-5)
      pixiApp.stage.pivot.set(s2.x, s2.y);

      //const sss = pixiApp.stage.scale;
      //pixiApp.stage.scale.set(sss.x*3,sss.y*3)

      this.$refs.renderTools.render();


      });
      });
      //pixiApp.start();

    }
  },
  mounted() {
  },

  beforeCreate() {
  },
  beforeDestroy() {
  },
  computed:{
  }
}
</script>
